// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalUpdate_root__3KSyq","footer":"ModalUpdate_footer__2kdt4"};